import { Chip, ChipProps, styled } from '@mui/material';

interface Props extends ChipProps {
  backgroundColor?: string;
  textColor?: string;
}

export const ChipCustom = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'textColor',
})<Props>`
  background-color: ${(props) => props.backgroundColor || 'default'};
  color: ${(props) => props.textColor || 'inherit'};
`;
